import Vue from 'vue'
import UploadImageFileOrUrl from '~/components/shared/client/UploadImageFileOrUrl'
Vue.component('UploadImageFileOrUrl', UploadImageFileOrUrl)
